import { useQuery } from '@tanstack/react-query'
import { useChainId, useConfig } from 'wagmi'

import { stusdsWithdrawDataQueryOptions } from '../../../withdraw/logic/stusds/stusdsWithdrawDataQuery'
import { StusdsWarningData } from '../../types'

export function useStusdsWarningData(): StusdsWarningData | undefined {
  const chainId = useChainId()
  const wagmiConfig = useConfig()
  const { data } = useQuery(stusdsWithdrawDataQueryOptions({ wagmiConfig, chainId }))

  const debt = data?.lockstakeDebt
  const totalAssets = data?.totalAssets

  return (
    debt &&
    totalAssets && {
      debt,
      totalAssets,
    }
  )
}
